module.exports = __webpack_public_path__ + "img/address.78795c0b.png";